import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST /files/getdownloadurl</h1>
        </div>
        <p>
          Returns a URL for downloading a file uploaded within a message. Files
          must previously have been uploaded to Google Cloud Storage using a URL
          generated by{" "}
          <Link to="/api/files/files_getuploadurl">getuploadurl</Link>. For more
          information, see the{" "}
          <Link to="/guides/filesystem">File System Guide</Link>.
        </p>
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>fileKeys</td>
                <td>An array of file IDs.</td>
                <td>Array of strings</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>PERM_TOPIC_READ</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/files/getdownloadurl
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"fileKeys": ["7603a87b-ebf3-4028-b853-a77a00fe5d33"]{"\n"}
          {"}"}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data": [{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"fileKey": "7603a87b-ebf3-4028-b853-a77a00fe5d33",{"\n"}
          {"      "}"url":
          "https://storage.googleapis.com/onesnatesting/logan%2F7603a87b-ebf3-4028-b853-a77a00fe5d33?GoogleAccessId=logan-testing@onesnatesting.iam.gserviceaccount.com&amp;Expires=1493150432&amp;Signature=c6eQc8pu%2FUcmMB823vTpZXkDj6KDjnT%2FaYpuC6dGeNTJjwKLbACjvkp9Lfh3SvGMTQLSTI%2BjEROz8jQJsVvwnHL8g83%2BSl3AbkzkVzvUJtRzqVGlmqbwG0VUaAc29bGfGSHx7FJR%2BJOQq80OV2KBc0y0ORIv5JRm5ze6m6twS5HtKOK%2FP11qwZfIXh1x6w%2FRrYVTpWGsjuIXPpJ1G%2FLiiDRtitDgowLfRLt3H402g0JATBq5%2Bn9r5vPG7%2Bh2%2BMUyejyo50HZ5LIEkkNqHSNuc6fcrDdJkV4zV%2FlqQuPmZYBIWFhXKGQ6rcHleZ61pjSgUPOlxd%2FsY6kKOKkcLizVgg%3D%3D"
          {"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"  "}]{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
